import { useEffect, useState } from 'react';
import { Dropdown, Stack } from 'rsuite';
import PeoplesIcon from '@rsuite/icons/Peoples';
import {
  useAppDispatch,
  useAppSelector,
  useLazyRegionLoginQuery
} from '@monorepo/shared';
import {
  selectGroupRegions,
  selectHaCurrentGroup,
  selectHaGroups,
  selectHasGroup,
  updateHaCurrentGroup
} from '@monorepo/shared/store/groupSlice';

export const GroupDropdown = () => {
  const dispatch = useAppDispatch();
  const hasGroup = useAppSelector(selectHasGroup);
  const groups = useAppSelector(selectHaGroups);
  const groupRegions = useAppSelector(selectGroupRegions);
  const [regionLogin] = useLazyRegionLoginQuery();

  const currentHaGroup = useAppSelector(selectHaCurrentGroup);
  const onSelect = (item: any, event: any) => {
    dispatch(updateHaCurrentGroup(item));
  };

  useEffect(() => {
    if (Object.keys(groupRegions).length > 0) {
      console.log('groupRegions changed:', groupRegions, groups);
      Object.values(groupRegions)?.map((region: Record<string, any>) => {
        if (region && region?.globalToken && !region?.token) {
          regionLogin({ region: region });
        }
      });
    }
  }, [groupRegions]);

  return hasGroup ? (
    <div className="group-dropdown">
      <Stack spacing={8}>
        <PeoplesIcon style={{ fontSize: '1.5em' }} />
        <Stack.Item grow={1}>
          <Dropdown
            appearance="default"
            size="sm"
            title={currentHaGroup?.desc}
            style={{ width: '100%' }}
          >
            {Object.values(groups).map(
              (obj: Record<string, any>, idx: number) => (
                <Dropdown.Item
                  style={{ padding: '10px 20px' }}
                  key={idx + 1}
                  onSelect={(e) => onSelect(obj, e)}
                  active={currentHaGroup?.id === obj?.id}
                >
                  {obj?.desc || obj?.name}
                </Dropdown.Item>
              )
            )}
          </Dropdown>
        </Stack.Item>
      </Stack>
    </div>
  ) : (
    <></>
  );
};

export default GroupDropdown;
